import React from "react";
import "./BusReviewPage.css";
import { ClipLoader } from "react-spinners";

const BusReviewPassenger = ({
  onConfirm,      // use same name as parent
  onClose,        // for closing modal
  travellers,
  busDetails,
  totalFare,
  confirmLoading,
}) => {
  return (
    <div className="review_passenger_detail">
      <div className="overlayss">
        <p className="overlayBggg" />
        <div className="BusReviewPage-commonOverlay">
          <span
            className="bgProperties overlayCrossIcon icon20"
            style={{
              backgroundImage:
                'url("https://jsak.mmtcdn.com/flights/assets/media/cross-icon.png")',
            }}
            onClick={onClose}
          />
          <h3 className="fontSize24 boldFont appendBottom12">
            Review Bus Booking
          </h3>
          <p className="darkText review_page_para">
            Please ensure that the passenger names and seat details are correct
            before confirming your booking.
          </p>

          <div className="reviewDtlsOverlayContent customScroll">
            {/* === Traveller Details === */}
            {travellers && travellers.length > 0 && (
              <div>
                {travellers.map((t, index) => (
                  <div key={index} className="tvlrDtlsCard">
                    <p className="makeFlex appendBottom7 title">
                      <span className="blackText blackFont">
                        PASSENGER {index + 1}
                      </span>
                    </p>
                    <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Name</span>
                      <span className="blackText boldFont flexOne">
                        {t.title} {t.firstName} {t.lastName}
                      </span>
                    </p>
                    <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Gender</span>
                      <span className="blackText boldFont flexOne">
                        {t.title === "Mr" ? "Male" : "Female"}
                      </span>
                    </p>
                    <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Age</span>
                      <span className="blackText boldFont flexOne">
                        {t.age || "N/A"}
                      </span>
                    </p>
                    <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Seat No.</span>
                      <span className="blackText boldFont flexOne">
                        {t.seat || "—"}
                      </span>
                    </p>
                    {/* <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Fare</span>
                      <span className="blackText boldFont flexOne">
                        ₹{Math.round (t.fare)}
                      </span>
                    </p> */}
                  </div>
                ))}
              </div>
            )}

            {/* === Bus Journey Details === */}
            {/* {busDetails && (
              <div className="tvlrDtlsCard">
                <p className="makeFlex appendBottom7 title">
                  <span className="blackText blackFont">JOURNEY DETAILS</span>
                </p>
                <p className="makeFlex appendBottom7">
                  <span className="tvlrLftInfo">From</span>
                  <span className="blackText boldFont flexOne">
                    {busDetails.origin}
                  </span>
                </p>
                <p className="makeFlex appendBottom7">
                  <span className="tvlrLftInfo">To</span>
                  <span className="blackText boldFont flexOne">
                    {busDetails.destination}
                  </span>
                </p>
                <p className="makeFlex appendBottom7">
                  <span className="tvlrLftInfo">Departure</span>
                  <span className="blackText boldFont flexOne">
                    {busDetails.departureTime
                      ? new Date(busDetails.departureTime).toLocaleString()
                      : "—"}
                  </span>
                </p>
                <p className="makeFlex appendBottom7">
                  <span className="tvlrLftInfo">Arrival</span>
                  <span className="blackText boldFont flexOne">
                    {busDetails.arrivalTime
                      ? new Date(busDetails.arrivalTime).toLocaleString()
                      : "—"}
                  </span>
                </p>
              </div>
            )} */}

            {/* === Fare Summary === */}
            {/* <div className="tvlrDtlsCard">
              <p className="makeFlex appendBottom7 title">
                <span className="blackText blackFont">FARE SUMMARY</span>
              </p>
              <p className="makeFlex appendBottom7">
                <span className="tvlrLftInfo">Total Fare</span>
                <span className="blackText boldFont flexOne">
                  ₹{totalFare || 0}
                </span>
              </p>
            </div> */}
          </div>

          {/* === Footer Actions === */}
          <div className="detailsPopupFooter">
            <span
              className="review_pass_editt appendRight20 linkText busreview-editBtn"
              onClick={onClose}
            >
              EDIT
            </span>
            <button
              onClick={onConfirm}
              type="button"
              className="button buttonPrimary buttonBig fontSize14 review_pass_condifmr"
              disabled={confirmLoading} // prevent double clicks
            >
              {confirmLoading ? (
                <ClipLoader color="#fff" size={20} />
              ) : (
                "CONFIRM"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusReviewPassenger;
